// frontend/src/utils/tierLadder.js — PRD-65 Phase 3
//
// Frontend mirror of api/shared/tierLadder.js. Encodes the order of paid tiers
// and the rule "skip same-cap tiers in upsell copy" (Trial=Standard=1000 → both
// upsell to Pro=2000, not to each other).
//
// Cap values mirror api/shared/tierConfig.js. If those change, update both.

export const TIER_ORDER = ['trial', 'standard', 'pro', 'enterprise'];

export const TIER_DISPLAY_LABEL = {
    trial: 'Trial',
    standard: 'Standard',
    pro: 'Pro',
    enterprise: 'Enterprise'
};

export const TIER_MAX_SCAN_URLS = {
    trial: 1000,
    standard: 1000,
    pro: 2000,
    enterprise: null
};

function normalize(tier) {
    return tier === 'free' ? 'trial' : tier;
}

/**
 * Returns { cap, tier, label } for the next tier whose maxScanUrls is STRICTLY
 * greater than the current tier's cap. Same-cap tiers are skipped.
 *
 * Returns { cap: null, tier: null, label: null } when the user is already on
 * Enterprise (unlimited) or the tier is unknown.
 */
export function getNextMeaningfulTierCap(currentTier) {
    const normalized = normalize(currentTier);
    const currentCap = TIER_MAX_SCAN_URLS[normalized];

    if (currentCap === null) return { cap: null, tier: null, label: null };

    const idx = TIER_ORDER.indexOf(normalized);
    if (idx < 0) return { cap: null, tier: null, label: null };

    for (let i = idx + 1; i < TIER_ORDER.length; i++) {
        const nextTier = TIER_ORDER[i];
        const nextCap = TIER_MAX_SCAN_URLS[nextTier];
        if (nextCap === null) {
            return { cap: null, tier: nextTier, label: TIER_DISPLAY_LABEL[nextTier] };
        }
        if (typeof nextCap === 'number' && typeof currentCap === 'number' && nextCap > currentCap) {
            return { cap: nextCap, tier: nextTier, label: TIER_DISPLAY_LABEL[nextTier] };
        }
    }
    return { cap: null, tier: null, label: null };
}

export function tierDisplayLabel(tier) {
    return TIER_DISPLAY_LABEL[normalize(tier)] || tier || 'your tier';
}
